String.prototype.nl2br = function () {
	return (`${this}`).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2')
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js